import {
  ModalHeader,
  Text,
  Flex,
  ModalBody,
  ModalFooter,
  spaces,
} from '@electricjs/arc';

type AccessConfigurationStepWrapperProps = {
  title: string;
  description: string | React.ReactNode;
  children: React.ReactNode | React.ReactNode[];
  footerActions: React.ReactNode | React.ReactNode[];
};

export const AccessConfigurationStepWrapper = ({
  title,
  description,
  children,
  footerActions,
}: AccessConfigurationStepWrapperProps) => {
  const { space_m } = spaces;

  return (
    <>
      <ModalHeader>
        <Text variant="heading-2">{title}</Text>
      </ModalHeader>
      <ModalBody p={space_m} overflowY="auto" minHeight="48rem">
        <Flex flexDirection="column" gap={space_m}>
          <Text>{description}</Text>
          {children}
        </Flex>
      </ModalBody>
      <ModalFooter p={space_m}>{footerActions}</ModalFooter>
    </>
  );
};
